import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import NewOrder from "@/pages/NewOrder";
import Users from "@/pages/Users";
import Employees from "@/pages/Employees";
import EmployeeProfile from "@/pages/EmployeeProfile";
import Chat from "@/pages/Chat";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Wallet from "@/pages/Wallet";
import Payments from "@/pages/Payments";
import ServiceDashboard from "@/pages/ServiceDashboard";
import ActivityLog from "@/pages/ActivityLog";
import Tickets from "@/pages/Tickets";
import ConnectorReports from "@/pages/ConnectorReports";
import ConnectorReportDetail from "@/pages/ConnectorReportDetail";
import Invoices from "@/pages/Invoices";
import InvoiceEditor from "@/pages/InvoiceEditor";

const AppShell = ({ children }) => <Layout>{children}</Layout>;
const Guard = ({ children, role }) => <ProtectedRoute role={role}><AppShell>{children}</AppShell></ProtectedRoute>;

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Guard><Dashboard /></Guard>} />
            <Route path="/leads" element={<Guard><Leads /></Guard>} />
            <Route path="/leads/:id" element={<Guard><LeadDetail /></Guard>} />
            <Route path="/new-order" element={<Guard><NewOrder /></Guard>} />
            <Route path="/services/:serviceType" element={<Guard><ServiceDashboard /></Guard>} />
            <Route path="/employees" element={<Guard role="admin"><Employees /></Guard>} />
            <Route path="/employees/:id" element={<Guard role="admin"><EmployeeProfile /></Guard>} />
            <Route path="/users" element={<Guard role="admin"><Users /></Guard>} />
            <Route path="/payments" element={<Guard><Payments /></Guard>} />
            <Route path="/wallet" element={<Guard><Wallet /></Guard>} />
            <Route path="/chat" element={<Guard><Chat /></Guard>} />
            <Route path="/tickets" element={<Guard><Tickets /></Guard>} />
            <Route path="/reports" element={<Guard><Reports /></Guard>} />
            <Route path="/reports/connectors" element={<Guard><ConnectorReports /></Guard>} />
            <Route path="/reports/connectors/:id" element={<Guard><ConnectorReportDetail /></Guard>} />
            <Route path="/invoices" element={<Guard><Invoices kind="invoice" /></Guard>} />
            <Route path="/invoices/:id" element={<Guard><InvoiceEditor kind="invoice" /></Guard>} />
            <Route path="/quotations" element={<Guard><Invoices kind="quotation" /></Guard>} />
            <Route path="/quotations/:id" element={<Guard><InvoiceEditor kind="quotation" /></Guard>} />
            <Route path="/activity" element={<Guard role="admin"><ActivityLog /></Guard>} />
            <Route path="/settings" element={<Guard><Settings /></Guard>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
